<template>
    <div ref="slider" class="chart-wrapper">
        <div :style="getWidth">
            <canvas
                ref="canvas"
                role="img"
                class="chart"
                :height="height"
                :aria-label="name"
            />
        </div>
    </div>
</template>
<script>
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

export default {
    name: "BaseChart",
    props: {
        name: {
            type: String,
            required: true,
        },
        height: {
            type: Number,
            default: 300,
        },
        options: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            chart: null,
        };
    },
    computed: {
        getWidth() {
            const length = this.options.data?.labels?.length;
            const minWidth = Math.max(length * 50, 300);
            const maxWidth = Math.min(length * 100, 1100);

            if (!length) {
                return {};
            }

            return {
                "max-width": `${maxWidth}px`,
                "min-width": `${minWidth}px`,
            };
        },
    },
    mounted() {
        this.chart = new Chart(
            this.$refs.canvas.getContext("2d"),
            this.options
        );
    },
};
</script>
